'use strict';

/**
 * Controller definition for AlbumModule
 *
 * @category   Cantroller
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.de)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoController = require('base/Colido.Controller');
var ModalLayout = require('./views/layout/modal');

var AlbumModuleController = ColidoController.extend({
    routes: {
        'photobox': 'actionShow',
    },

    initialize: function (options) {
        this.module = this.getOption('module');
        this.app = this.getOption('app');
    },

    /**
     * Action for listing the locations / storages and undefinied objects
     */
    actionShow: function() {
        this.onDataReady([
            'collection:albums:photobox',
            'collection:albums:unused',
        ], function(ready) {
            var region = App.rootView.mainRegion.currentView.contentRegion;

            //var collection = LocationModule.locationsCollection;

            App.vent.trigger('collection:albums:photobox:reload');
            App.vent.trigger('collection:albums:unused:reload');

            var layout = new ModalLayout({
                collectionPhotobox: this.module.albumsPhotoboxCollection,
                collectionUnused: this.module.albumsUnusedCollection,
            });

            region.show(layout);
        });
    },
});

module.exports = AlbumModuleController;